import {userConstants} from '../_constants';

export function promoCodes(state = {}, action) {
  switch (action.type) {
    case userConstants.PROMO_CODES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userConstants.PROMO_CODES_SUCCESS:
      return {
        ...state,
        ...action.data,
        loading: false,
      };
    case userConstants.PROMO_CODES_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}